import React from 'react';
import { AnimateOnScroll } from './AnimateOnScroll';
function WavyUnderline() {
  return <svg className="w-full h-2 mt-0.5" viewBox="0 0 200 8" fill="none" preserveAspectRatio="none" data-id="element-2">
      <path d="M0,4 Q10,0 20,4 T40,4 T60,4 T80,4 T100,4 T120,4 T140,4 T160,4 T180,4 T200,4" stroke="#FF1493" strokeWidth="2.5" fill="none" data-id="element-3" />
    </svg>;
}
function SectionDivider() {
  return <div className="flex flex-col mb-16 items-center justify-start" data-id="element-4">
      <img src="https://cdn.magicpatterns.com/uploads/oCf7AFJw67JMTtU3gnEHdW/Group_169.png" alt="" className="h-auto" style={{
      width: '18px'
    }} data-id="element-5" />
    </div>;
}
export function ApproachSection() {
  return <section id="about" className="bg-[#E8E8E8] pt-12 pb-24 lg:pb-32 overflow-hidden" data-id="element-6">
      {/* Section Divider */}
      <div className="mb-16" data-id="element-7">
        <SectionDivider data-id="element-8" />
      </div>

      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-9">
        <div className="flex flex-col-reverse md:flex-col-reverse lg:flex-row items-start gap-12 lg:gap-20" data-id="element-10">
          {/* Left Column - Text (55%) */}
          <AnimateOnScroll className="w-full lg:w-[55%]" data-id="element-11">
            <p className="font-serif italic text-base text-gray-600 mb-6" data-id="element-12">
              (At Be CLINICAL)
            </p>

            <h2 className="text-3xl sm:text-4xl md:text-[44px] lg:text-5xl text-black uppercase leading-[1.05] mb-10 font-[600] font-[Poppins,_sans-serif]" data-id="element-13">
              OUR APPROACH EXTENDS BEYOND{' '}
              <span className="inline-block" data-id="element-14">
                <span className="text-[#FF1493]" data-id="element-15">CONVENTIONAL</span>
                <WavyUnderline data-id="element-16" />
              </span>{' '}
              TREATMENTS
            </h2>

            <div className="space-y-6 font-body text-base text-gray-700 leading-relaxed" data-id="element-17">
              <p data-id="element-18">
                Led by Dr. Fiona, our team is dedicated to{' '}
                <strong className="text-black font-[Poppins,_sans-serif]" data-id="element-19">
                  understanding each individual's unique needs and aspirations.
                </strong>
              </p>
              <p className="font-[Poppins,_sans-serif]" data-id="element-20">
                We tailor every treatment to not only enhance physical beauty
                but also to bolster self-esteem and overall well-being.
              </p>
              <p className="font-[Poppins,_sans-serif]" data-id="element-21">
                Our commitment to your health and happiness is at the core of
                everything we do, ensuring that each visit leaves you feeling
                renewed and empowered to face the world with confidence.
              </p>
            </div>
          </AnimateOnScroll>

          {/* Right Column - Image (45%) */}
          <AnimateOnScroll className="w-full lg:w-[45%] relative" delay={200} data-id="element-22">
            <div className="relative" data-id="element-23">
              <img src="https://cdn.magicpatterns.com/uploads/h3f4NACsVgB1w92SnYDt9y/Group_190_(1).png" alt="Close up of beauty treatment with injection near jawline - Empowering Confidence" className="w-full aspect-[3/4] object-cover" data-id="element-24" />
            </div>
          </AnimateOnScroll>
        </div>
      </div>
    </section>;
}